import {
    Controller
} from "stimulus"
import PubSub from 'pubsub-js'
import waitForElement from "wait-for-element"

export default class extends Controller {
    static targets = ['pagination', 'step', 'form', 'title']
    currentStep
    onFormSuccess
    formSuccessObserver

    get currentIndex() {
        return this.currentStep.dataset.step
    }

    get currentTitle() {
        return this.currentStep.dataset.title
    }

    get form() {
        return document.getElementById('tour__form')
    }

    get success() {
        return this.element.querySelector('.form-success')
    }


    connect() {
        this.openStep(
            this.stepTargets[0]
        )
        this.formSuccessObserver = new MutationObserver((mutationsList, observer) => {
            if(this.success) {
                console.log('success!')
                observer.disconnect()
                this.next()
            }
        }).observe(this.element, {
            childList: true,
            subtree: true
        });
    }

    openStep(step) {
        Array.from(this.stepTargets).forEach(el => el.classList.add('d-none'))
        step.classList.remove('d-none')
        this.currentStep = step
        this.element.classList.remove('tour--step-1')
        this.element.classList.remove('tour--step-2')
        this.element.classList.add('tour--step-' + this.currentIndex)
        this.titleTarget.innerText = this.currentTitle
    }

    next() {
        this.openStep(
            this.stepTargets[1]
        )
    }

    prev() {
        this.openStep(
            this.stepTargets[0]
        )
    }


    open() {
        PubSub.publish('MODAL_OPEN', 'tour-modal');
    }

    close() {
        PubSub.publish('MODAL_CLOSE', 'tour-modal');
    }

    disconnect() {
        this.formSuccessObserver.disconnect()
    }
}